<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-06-23 13:19:10
 * @FilePath: /mrc-ess-fronted/src/Page/EssAdmin/CompanyManagement/Tax/components/editFiles.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-06-23 16:06:43
-->
<template>
  <normalDialog
    :title="$t('label_essweb_Tax_form_editTitle')"
    :dialog="show"
    maxWidth="600"
    width="600"
    @close="$emit('close')"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row align="center">
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              isRequire
              :rules="$GetRules(['_Require_Rules'], [null])"
              v-model="fileInfo.doc_title"
              :label="$t('label_essweb_Tax_list_fileNameLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <DateTimePicker
              type="date"
              :label="$t('label_essweb_List_dialog_DateLabel')"
              :defaultTime="fileInfo.release_utc_datetime"
              placeholder="YYYY/MM/DD"
              @change="
                (time) => {
                  fileInfo.release_utc_datetime = time;
                }
              "
            ></DateTimePicker>
          </v-col> </v-row
      ></v-form>
    </template>
    <template v-slot:actions>
      <CardActions submitBtn @submit="toSubmit" @cancel="$emit('close')" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "editFiles",
  props: {
    show: { default: false, type: Boolean },
    propertyData: { default: null, type: [Object, Array] },
  },
  computed: {
    ...mapGetters(["AppInfo", "companyLang", "defaultLang"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
  },
  watch: {
    show(val) {
      if (!val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.fileInfo = {
          uuid: null,
          doc_title: "",
          release_utc_datetime: "",
        };
      }
    },
    propertyData(val) {
      if (val) {
        val.release_utc_datetime = this.$getDateTime(
          val.release_utc_datetime,
          "YYYY-MM-DD"
        );
        this.fileInfo = JSON.parse(JSON.stringify(val));
      }
    },
  },
  data() {
    return {
      fileInfo: {
        uuid: null,
        doc_title: "",
        release_utc_datetime: "",
      },
    };
  },
  mounted() {},
  methods: {
    toSubmit() {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("submit", this.fileInfo);
    },
  },
};
</script>